// extracted by mini-css-extract-plugin
export default {"param":"iAvMb","text":"S003q","value":"S4e7c"};